import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { categories as mockCategories } from "../mock";
import { fetchCategories } from "../api";

const CategoryGrid = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState(mockCategories);

  useEffect(() => {
    fetchCategories()
      .then((d) => d?.length && setCategories(d))
      .catch(() => {});
  }, []);

  const items = [...categories.slice(0, 8), categories[9]].filter(Boolean);

  return (
    <section>
      <div className="flex items-center mb-3.5">
        <h2 className="text-[18px] font-bold text-gray-800">Shop by Category</h2>
        <button
          onClick={() => navigate("/categories")}
          className="ml-auto flex items-center gap-1 text-[12.5px] font-semibold text-[#0e7a3d] hover:gap-2 transition-all"
        >
          View All Categories <ArrowRight size={14} />
        </button>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 xl:grid-cols-9 gap-2.5">
        {items.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            style={{ backgroundColor: c.bg }}
            className="rounded-xl p-2.5 text-center hover:shadow-lg hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300"
          >
            <div className="h-16 rounded-lg overflow-hidden mb-2 bg-white/60">
              <img
                src={c.img}
                alt={c.name}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-[11px] font-bold leading-tight" style={{ color: c.color }}>
              {c.name}
            </div>
            <div className="text-[9px] text-gray-500 leading-tight mt-0.5 line-clamp-2 min-h-[22px]">
              {c.sub}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CategoryGrid;
